export const TEAM_COLOR_SWATCHES = [
  '#0357AE',
  '#15651C',
  '#A30000',
  '#4A2670',
  '#00606F',
  '#9C3600',
  '#AE0060',
  '#814800',
  '#394E5A',
  '#3C6000',
] as const;

export function resolveTeamColor(color: string | null | undefined): string {
  return color || TEAM_COLOR_SWATCHES[0];
}
